import { useSignal, useSignalEffect, useComputed } from "@preact/signals-react";

export function OptionButtons({
  options,
  defaultOption = null,
  onSelect = () => {},
  className = ""
}) {
  const optionSelected = useSignal(defaultOption);
  const optionList = useComputed(() => (options.map((option, i) => {
    const className = (optionSelected.value === option.value)
      ? "option-buttons__button active"
      : "option-buttons__button";
    return (
      <button
        key={i}
        className={className}
        onClick={() => optionSelected.value = option.value}
      >
        {option.label}
      </button>
    );
  })));
  useSignalEffect(() => {
    onSelect(optionSelected.value);
  });

  return (
    <div className={`${className} option-buttons`}>
      {optionList}
    </div>
  );
}